






















import { editFactory } from '@/main/pages/editFactory';
import MaskaModeluSelect from '@/modules/ciselnik/dilenske/components/MaskaModeluSelect.vue';
import { VozidloPujcovna } from '@/modules/pujcovna/vozidloPujcovna';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		VozidloPujcovnaSelect: VozidloPujcovna.components.Select,
		MaskaModeluSelect,
	},
	computed: {
		mutationsMappers() {
			return {
				maskaModelu: `${this.storeUri}/${editMutations.NAHRADNI_SAZBA_MASKA_MODELU_SELECT_MAPPER}`,
				vozidloPujcovna: `${this.storeUri}/${editMutations.NAHRADNI_SAZBA_VOZIDLO_PUJCOVNA_SELECT_MAPPER}`,
			};
		},
	},
	methods: {
		updateVyrobekvozOzn(value: string) {
			this.VyrobekvozOzn = value;

			this.TypMaska = null;
			this.TypMaskaText = null;
			this.VozidlopaId = null;
			this.VozidloRzv = null;
			this.VozidloVin = null;
		},
	},
});
